export { FixedAccordion } from "./fixed-accordion";